import { gql } from '@apollo/client';

export const CONFIRM_PAYMENT = gql`
  mutation wConfirmPayment(
    $uid: UUID
    $clientIp: String
    $ecomToken: String
    $almToken: String
  ) {
    wConfirmPayment(
      uid: $uid
      clientIp: $clientIp
      ecomToken: $ecomToken
      almToken: $almToken
    )
  }
`;
